import { getDocument } from '@zurich/api/document';
import { useFetchApi, useTranslation } from '@zurich/common/hooks';
export const useGetDocument = () => {
    const { t } = useTranslation();
    const { fetchApi } = useFetchApi();
    const handleFetch = async (documentId) => {
        return await fetchApi(getDocument, { vars: { documentId } }, {
            errorText: t('events.errors.getDocument'),
        });
    };
    return handleFetch;
};
